// @flow
import { takeEvery, put, call, select } from 'redux-saga/effects';
import type { ActionType } from 'redux-actions';
import {
  requestChannelStats,
  requestBrandEngageChannelStats,
  receiveChannelStats,
} from './channelStatsActions';
import {
  getChannelStats,
  getbrandEngageChannelsStats,
} from './channelStatsApi';
import { selectToken } from 'ducks/SagaUtils';

function* fetchChannelStats(
  action: ActionType<typeof requestChannelStats>
): Generator<*, *, *> {
  const token = yield select(selectToken);
  const { clientId, channelName, worklist } = action.payload;

  try {
    const response = yield call(
      getChannelStats,
      token,
      clientId,
      channelName,
      worklist
    );
    yield put(receiveChannelStats(response, action.payload));
  } catch (err) {
    yield put(receiveChannelStats(err, action.payload));
  }
}

function* fetchBrandEngageChannelStats(
  action: ActionType<typeof requestBrandEngageChannelStats>
): Generator<*, *, *> {
  const token = yield select(selectToken);
  const { clientId, channelName, brandEngageType } = action.payload;

  try {
    const response: string = yield call(
      getbrandEngageChannelsStats,
      token,
      brandEngageType,
      clientId,
      channelName
    );

    const count = {
      [channelName]: +response,
    };
    yield put(receiveChannelStats(count, action.payload));
  } catch (err) {
    yield put(receiveChannelStats(err, action.payload));
  }
}

export default function*(): Generator<*, *, *> {
  yield takeEvery(requestChannelStats, fetchChannelStats);
  yield takeEvery(requestBrandEngageChannelStats, fetchBrandEngageChannelStats);
}



// WEBPACK FOOTER //
// ./src/containers/channels/channelStatsSaga.js